import { FC, ReactElement } from 'react';
import styled from '@emotion/styled';
import TopBar from '../connected/TopBar';
import SideBar from '../connected/SideBar';

type Props = {
  children: ReactElement<any>;
  className?: string;
};

const IframeLayout: FC<Props> = ({ children, className }) => {
  return (
    <Root className={className}>
      <TopBar />
      <SideBar />
      <Content>{children}</Content>
    </Root>
  );
};

const Root = styled('div')({
  height: '100%',
  paddingLeft: 302,
});

const Content = styled.main((props) => ({
  height: '100%',
  paddingTop: props.style ? props.style.paddingTop : undefined,
}));

export default IframeLayout;
